import { render, staticRenderFns } from "./WebCamForm.vue?vue&type=template&id=2ce63f8e&scoped=true"
import script from "./WebCamForm.vue?vue&type=script&lang=js"
export * from "./WebCamForm.vue?vue&type=script&lang=js"
import style0 from "./WebCamForm.vue?vue&type=style&index=0&id=2ce63f8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce63f8e",
  null
  
)

export default component.exports